var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"视频播放","visible":_vm.dialogVisible,"width":"50%"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('div',{staticClass:"videoArea"},[_c('video',{ref:"videoRef",attrs:{"width":"100%","height":"100%","controls":"","src":_vm.videoUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }